// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/Anchors/Confirmation/styles.scss
// module id = 1369
// module chunks = 0